import { render, staticRenderFns } from "./SelectDataSlave.vue?vue&type=template&id=2974b6f0"
import script from "./SelectDataSlave.vue?vue&type=script&lang=js"
export * from "./SelectDataSlave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports